import { atom } from "recoil";
import { setTaskEditorTasksCache } from "pages/task-editor/utils/taskEditorRuntime";
import type { TaskEditorState } from "pages/task-editor/utils/taskEditorUtils";

export const taskEditorTasksByTaskIdAtom = atom<
  Record<string, TaskEditorState>
>({
  key: "taskEditorTasksByTaskIdAtom",
  default: {},
  effects_UNSTABLE: [
    ({ onSet }) => {
      setTaskEditorTasksCache({});
      onSet((nextTasks: Record<string, TaskEditorState>) => {
        setTaskEditorTasksCache(nextTasks);
      });
    },
  ],
});

export const taskEditorStoreHydratedAtom = atom<boolean>({
  key: "taskEditorStoreHydratedAtom",
  default: false,
});

export const taskEditorStoreLoadingAtom = atom<boolean>({
  key: "taskEditorStoreLoadingAtom",
  default: false,
});
